export const CHANGE_VERSION_AUTH = 'CHANGE_VERSION_AUTH';

export const changeVersionAuth = (payload) => {
	return {
		type: CHANGE_VERSION_AUTH,
		payload,
	};
};
